import get from 'lodash/get';
import * as tagTagFeaturedActions from '../../action_creators/tag/tag_featured_feed_action_creators';
import TagTagFeaturedModel from '../../../models/tag/tag_featured_feed';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagTagFeaturedActions.tagFeaturedFeedLoading({}, store));
    return TagTagFeaturedModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(tagTagFeaturedActions.tagFeaturedFeedLoaded(resp.data, store));
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (params.tag !== 'living-smarter') {
          if (status === 404) {
            dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          } else {
            dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
            log.error(
              err,
              `Error in tag featured feed actions, message: ${err.message}`
            );
          }
        }
        dispatch(tagTagFeaturedActions.tagFeaturedFeedLoadError(err, store));
      });
  };
}
